import { jsx } from "react/jsx-runtime";
import { useVoicePersona } from "../../theme/useVoicePersona.js";
import { AuroraBlob } from "./AuroraBlob.js";
import { MetaballBlob } from "./MetaballBlob.js";
import { OrganicBlob } from "./OrganicBlob.js";
import { ParticleBlob } from "./ParticleBlob.js";
import { RippleBlob } from "./RippleBlob.js";
import { WaveformBlob } from "./WaveformBlob.js";
import { useBlobLevel } from "./useBlobLevel.js";
const VoiceBlob = ({ state, size = 240, styleOverride, colors }) => {
  const persona = useVoicePersona();
  const effectiveStyle = styleOverride ?? persona.blobStyle;
  const level = useBlobLevel(state);
  const effectiveColors = colors ?? persona.blobColorsAll[effectiveStyle];
  let inner;
  switch (effectiveStyle) {
    case "organic":
      inner = /* @__PURE__ */ jsx(OrganicBlob, { level, size, colors: effectiveColors });
      break;
    case "particle":
      inner = /* @__PURE__ */ jsx(ParticleBlob, { level, size, colors: effectiveColors });
      break;
    case "waveform":
      inner = /* @__PURE__ */ jsx(WaveformBlob, { level, size, colors: effectiveColors });
      break;
    case "ripple":
      inner = /* @__PURE__ */ jsx(RippleBlob, { level, size, colors: effectiveColors });
      break;
    case "metaball":
      inner = /* @__PURE__ */ jsx(MetaballBlob, { level, size, colors: effectiveColors });
      break;
    case "aurora":
    default:
      inner = /* @__PURE__ */ jsx(AuroraBlob, { level, size, colors: effectiveColors });
      break;
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: {
        width: size,
        height: size,
        display: "grid",
        placeItems: "center",
        // Keep aurora blend modes inside the orb (light page bg otherwise washes to white).
        isolation: effectiveStyle === "aurora" ? "isolate" : void 0
      },
      "aria-label": `Voice blob (${state})`,
      role: "img",
      children: inner
    }
  );
};
export {
  VoiceBlob,
  VoiceBlob as default
};
//# sourceMappingURL=index.js.map
